import React, { useRef, useEffect, useState, useContext, useCallback, useLayoutEffect } from 'react'
import { ConfirmDialog } from 'primereact/confirmdialog'; // To use <ConfirmDialog> tag
import { confirmDialog } from 'primereact/confirmdialog'; // To use confirmDialog method
import { Button, Calendar, Dropdown, InputText, Toast } from 'primereact'
import { Messages } from 'primereact/messages';
import { useParams } from 'react-router-dom';


import Card from '../../../Base/Components/Card/Card'
import { useForm } from '../../../Base/Hooks/useForm'
import { toastShow } from '../../../Base/Services/ToastService'
import { formatFecha } from '../../../Base/Services/FechasService'
import Loader from '../../../Base/Components/Loader/Loader';


import { getPersonalById } from '../../../API/RRHH/Personal/PersonalRequests'
import { calificaciones, competencias, concienciaCompromiso, tiempoEntrega, resumen } from './Data'
import { editarEvaluacionPersonal, getAllLisEvaluacion, getEvaluacion, getEvaluacionCREAR, getPerfilesPersonal, getPerfilesPersonalCREAR, guardarEvaluacionPersonal } from '../../../API/RRHH/Evaluacion/EvaluacionPersonalRequets';

import { AccesoUser, getAccesosWebUser } from '../../../API/IT/Accesos/AccesosRequests';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';

import './EvaluacionPersonalReporte.scss'

const EvaluacionPersonalScreen = () => {

  const { IdEvaluacion } = useParams();

  const dataBase = {
    codigo: '',
    NombreEmpleado: '',
    Responsabilidades: [],
    Objetivos: [],
    Indicadores: [],
    Mejoramiento: [],
    Competencias: competencias.map(e => { return { id: e.id, name: e.name, } }),
    TiempoEntrega: tiempoEntrega.map(e => { return { id: e.id, name: e.name, } }),
    ConcienciaCompromiso: concienciaCompromiso.map(e => { return { id: e.id, name: e.name, } }),
    Resumen: resumen.map(e => { return { id: e.id, name: e.name, } }),
    Cursos: []
  }

  const {values, handleInputChange, setValues, resetForm, setNumber, handleChange, error, setError} = useForm(dataBase);


  const toast = useRef(null);
  const messages = useRef(null);
  const scrollContainer = useRef(null);
  const scrollPosition = useRef(0);
  const isMinorUpdate = useRef(false);
  const [loading, setLoading] = useState(false);
  const [paso, setPaso] = useState(1);
  const [Responsabilidad, setResponsabilidad] = useState('')
  const [Objetivo, setObjetivo] = useState('');
  const [Indicador, setIndicador] = useState('');
  const [mejorameintoText, setMejorameintoText] = useState('');
  const [innovacionesText, setInnovacionesText] = useState('');
  const [metasTex, setMetasTex] = useState('');
  const [cursoText, setCursoText] = useState('');
  const [fechaText, setFechaText] = useState(null);
  const [efectividad, setEfectividad] = useState(null);
  const [comentariosDesarrolloText, setComentariosDesarrolloText] = useState('');
  const [isArea, setIsArea] = useState(false);
  const [posiciones, setPosiciones] = useState([]);
  const [info, setInfo] = useState([]);
  const [posicion, setPosicion] = useState(null);



  const { userAuth } = useContext(AuthContext);

  useEffect(() => {
    if (values?.idpersonal) {
      localStorage.setItem('evaluacion', JSON.stringify(values))
    }
  }, [values])

  useLayoutEffect(() => {
    if (isMinorUpdate.current && scrollContainer.current) {
      scrollContainer.current.scrollTop = scrollPosition.current;
      isMinorUpdate.current = false;
    }
  }, [values?.Competencias, values?.ConcienciaCompromiso, values?.TiempoEntrega, values?.Resumen])

  
  const getPerfiles = async () => {
    const infoTempo = await getAllLisEvaluacion()
    setInfo(infoTempo)
    if(IdEvaluacion){
      const t = await getPerfilesPersonal();
      setPosiciones(t);
    }else{
      if(values?.idpersonal){
        const e = await getPerfilesPersonalCREAR(values?.posicion)
        setPosiciones(e)
      }
    }
  }


  const getInfo = () => {
    console.log({IdEvaluacion});
    if (IdEvaluacion) {
      setValues(dataBase)
      getEvaluaEdit()
    } else{
      if(values?.idpersonal){
        // console.log("nueva evaluacion");
        getEvaluaCreate()
      }
    }
  }

  useEffect(() => {
    getInfo()
    window.document.title = 'PPF • Evaluación personal';
  }, [])


  const getEvaluaEdit = async () => {
    // if(userAuth.AccesosWeb.split(',').map(e => parseInt(e)).includes(25)){
      setLoading(true)
          const n = await getEvaluacion(IdEvaluacion);
          const t = n[0]
          const d = {
            ...t,
            codigo: t.idpersonal,
            Responsabilidades: t.seleccion.filter(e => e.IdPregunta === null).map(e => { return { Id: e.id, name: e.Pregunta, Comentario: e.Comentario, value: e.value, isNew: true } }),
            Competencias: competencias.map(e => {
              const respuesta = t.seleccion.filter(p => p.IdPregunta === e.id)[0]
              return { id: e.id, name: e.name, value: respuesta.value, Comentario: respuesta.Comentario }
            }),
            TiempoEntrega: tiempoEntrega.map(e => {
              const respuesta = t.seleccion.filter(p => p.IdPregunta === e.id)[0]
              return { id: e.id, name: e.name, value: respuesta.value, Comentario: respuesta.Comentario }
            }),
            ConcienciaCompromiso: concienciaCompromiso.map(e => {
              const respuesta = t.seleccion.filter(p => p.IdPregunta === e.id)[0]
              return { id: e.id, name: e.name, value: respuesta.value, Comentario: respuesta.Comentario }
            }),
            Resumen: resumen.map(e => {
              const respuesta = t.seleccion.filter(p => p.IdPregunta === e.id)[0]
              return { id: e.id, name: e.name, value: respuesta.value, Comentario: respuesta.Comentario }
            }),
            Cursos: t.list.filter(e => e.Tipo === 6).map(e => {
              return {
                nombre: e.valor,
                fecha: e.Fecha,
                efectividad: e.Efectividad,
                comentarios: e.Comentarios
              }
            }),
            Objetivos: t.list.filter(e => e.Tipo === 5).map(e => e.valor),
            Indicadores: t.list.filter(e => e.Tipo === 1).map(e => e.valor),
            Mejoramiento: t.list.filter(e => e.Tipo === 3).map(e => e.valor),
            Innovaciones: t.list.filter(e => e.Tipo === 2).map(e => e.valor),
            Metas: t.list.filter(e => e.Tipo === 4).map(e => e.valor),
      
          }
          setValues(d);
          setPaso(2);
          setLoading(false)
    // }else{
    //   toastShow(toast, 'warn', 'Usuario no tiene permisos para editar una evaluación')
    // }
  }

  const getEvaluaCreate = async () => {
    setLoading(true)
    // if(userAuth.AccesosWeb.split(',').map(e => parseInt(e)).includes(25)){
      const n = await getEvaluacionCREAR(values?.idpersonal);
      if(n.length > 0){
        const t = n[0]
        const d = {
          ...t,
          IdEvaluacion:-100,
          codigo: t.idpersonal,
          Responsabilidades: t.seleccion
            .filter((e) => e.IdPregunta === null)
            .map((e) => {
              return {
                Id: e.id,
                name: e.Pregunta,            
                Comentario: null,
                value: null,
                isNew: true,
              };
            }),
          Competencias: competencias.map((e) => {
            const respuesta = t.seleccion.filter((p) => p.IdPregunta === e.id)[0];
            return {
              id: e.id,
              name: e.name,
              Comentario: null,
              value: null,
            };
          }),
          TiempoEntrega: tiempoEntrega.map((e) => {
            const respuesta = t.seleccion.filter((p) => p.IdPregunta === e.id)[0];
            return {
              id: e.id,
              name: e.name,
              Comentario: null,
              value: null,
            };
          }),
          ConcienciaCompromiso: concienciaCompromiso.map((e) => {
            const respuesta = t.seleccion.filter((p) => p.IdPregunta === e.id)[0];
            return {
              id: e.id,
              name: e.name,
              Comentario: null,
              value: null,
            };
          }),
          Resumen: resumen.map((e) => {
            const respuesta = t.seleccion.filter((p) => p.IdPregunta === e.id)[0];
            return {
              id: e.id,
              name: e.name,
              Comentario: null,
              value: null,
            };
          }),
          Cursos: t.list
            .filter((e) => e.Tipo === 6)
            .map((e) => {
              return {
                nombre: e.valor,
                fecha: e.Fecha,
                efectividad: e.Efectividad,
                comentarios: e.Comentarios,
              };
            }),
          Objetivos: t.list.filter((e) => e.Tipo === 5).map((e) => e.valor),
          Indicadores: t.list.filter((e) => e.Tipo === 1).map((e) => e.valor),
          Mejoramiento: t.list.filter((e) => e.Tipo === 3).map((e) => e.valor),
          Innovaciones: t.list.filter((e) => e.Tipo === 2).map((e) => e.valor),
          Metas: t.list.filter((e) => e.Tipo === 4).map((e) => e.valor),
        };
        setValues({
          ...d,
          IdEvaluacion: -10
        });
        setPaso(2);
      }else{
        setValues({
          ...values,
          dataBase
        })
      }
    // }else{
    //   toastShow(toast, 'warn', 'Usuario no tiene permisos para editar una evaluación')
    // }
    setLoading(false)
  }

  const buscarPersona = async () => {
    setLoading(true);
    messages.current.clear();
    if (values?.codigo?.length > 0) {
      const codigo = values.codigo.padStart(5, '0');
      const personal = await getPersonalById(codigo)
      if (personal.length > 0) {
        setValues({
          ...personal[0], codigo,
          Responsabilidades: [],
          Objetivos: [],
          Indicadores: [],
          Competencias: competencias.map(e => { return { id: e.id, name: e.name, } }),
          TiempoEntrega: tiempoEntrega.map(e => { return { id: e.id, name: e.name, } }),
          ConcienciaCompromiso: concienciaCompromiso.map(e => { return { id: e.id, name: e.name, } }),
          Resumen: resumen.map(e => { return { id: e.id, name: e.name, } }),
          Mejoramiento: [],
          Innovaciones: [],
          Metas: [],
          Cursos: [],
        })

        if (personal[0].idseccion !== userAuth.idseccion) {
          setIsArea(false);
        } else {
          messages.current.clear();
          setIsArea(true);
        }
      } else {
        toastShow(toast, 'warn', 'Persona no encontrada.')
      }
    } else {
      toastShow(toast, 'warn', 'Ingrese un código de personal.')
    }
    setLoading(false);
  }


  const getPerfil = async () => {
    const t = await getEvaluacion(posicion?.IdEvaluacion);
    if (t.length > 0) {
      const resp = t[0].seleccion.filter(e => e.IdPregunta === null).map(e => {
        return { id: values?.Responsabilidades.length + 1, name: e.Pregunta, isNew: true }
      })
      const ind = t[0].list.filter(e => e.Tipo === 1).map(e => e.valor);
      const inov = t[0].list.filter(e => e.Tipo === 2).map(e => e.valor);
      const mejo = t[0].list.filter(e => e.Tipo === 3).map(e => e.valor);
      const metas = t[0].list.filter(e => e.Tipo === 4).map(e => e.valor);
      const obj = t[0].list.filter(e => e.Tipo === 5).map(e => e.valor);
      const curs = t[0].list.filter(e => e.Tipo === 6).map(e => {
        return {
          nombre: e.valor,
          fecha: new Date(e.Fecha),
          efectividad: e.Efeceividad,
          comentarios: e.Comentarios
        }
      });
      //  console.log(resp);
      setValues({
        ...values,
        Responsabilidades: resp,
        Indicadores: ind,
        Objetivos: obj,
        // Mejoramiento: mejo,
        // Innovaciones: inov,
        // Metas: metas,
        // Cursos: curs
      })
    }
  }



  const getCalificacion = () => {
    const desempeno = values.Responsabilidades.reduce((total, value) => {
      return total + calificaciones.filter(e => e.id === value.value)[0]?.value
    }, 0) / values.Responsabilidades.length * 100 / 5

    const competencias = values.Competencias.reduce((total, value) => {
      return total + calificaciones.filter(e => e.id === value.value)[0]?.value
    }, 0) / values.Competencias.length * 100 / values.Competencias.length

    const conciencia = values.ConcienciaCompromiso.reduce((total, value) => {
      return total + calificaciones.filter(e => e.id === value.value)[0]?.value
    }, 0) / values.ConcienciaCompromiso.length * 100 / 5

    const cumplimiento = values.TiempoEntrega.reduce((total, value) => {
      return total + calificaciones.filter(e => e.id === value.value)[0]?.value
    }, 0) / values.TiempoEntrega.length * 100 / 5

    // console.log({ desempeno, competencias, conciencia, cumplimiento });

    const promedio = (desempeno + competencias + conciencia + cumplimiento) / 4;
    return promedio;

  }

  const guardarEvaluacion = async () => {
    setLoading(true);
      if (values.IdEvaluacion >0) {
        const a = await editarEvaluacionPersonal({ ...values, Nota: getCalificacion().toFixed(2) });
        
        if (a?.guardado) {
          toastShow(toast, 'success', 'Evaluación editada.');
          setValues(dataBase);
          setPaso(1);
        }
      } else {
        const Anio = new Date().getFullYear();
        const evaluacionExistente = info.find(e => e.idpersonal === values?.idpersonal && e.Anio === Anio);
        if(evaluacionExistente){
          toastShow(toast, 'error', 'Error','Ya existe una evaluación guardada para este empleado.');
          setLoading(false)
        }else{
          const a = await guardarEvaluacionPersonal({ ...values, Nota: getCalificacion().toFixed(2), Anio });
          setLoading(false);
    
          if (a?.guardado) {
            toastShow(toast, 'success', 'Guardadada','Evaluación guardada correctamente.');
            setValues(dataBase);
            setPaso(1);
          }
        }
      }
    setLoading(false);
  }

  const addResponsabilidad = () => {
    if (Responsabilidad.length > 0) {
      handleChange([...values?.Responsabilidades, { id: values?.Responsabilidades.length + 1, name: Responsabilidad, isNew: true }], 'Responsabilidades')
      setResponsabilidad('')
    } else {
      toastShow(toast, 'warn', 'Ingrese una responsabilidad.')
    }
  }
  const addObjetivo = () => {
    if (Objetivo.length > 0) {
      handleChange([...values?.Objetivos, Objetivo], 'Objetivos')
      setObjetivo('')
    } else {
      toastShow(toast, 'warn', 'Ingrese un Objetivo.')
    }
  }
  const addIndicador = () => {
    if (Indicador.length > 0) {
      handleChange([...values?.Indicadores, Indicador], 'Indicadores')
      setIndicador('')
    } else {
      toastShow(toast, 'warn', 'Ingrese un Indicador.')
    }
  }
  const addMejoramiento = () => {
    if (mejorameintoText.length > 0) {
      handleChange([...values?.Mejoramiento, mejorameintoText], 'Mejoramiento')
      setMejorameintoText('')
    } else {
      toastShow(toast, 'warn', 'Ingrese un mejoramiento.')
    }
  }
  const addInnovaciones = () => {
    if (innovacionesText.length > 0) {
      handleChange([...values?.Innovaciones, innovacionesText], 'Innovaciones')
      setInnovacionesText('')
    } else {
      toastShow(toast, 'warn', 'Ingrese una inovación.')
    }
  }
  const addMetas = () => {
    if (metasTex.length > 0) {
      handleChange([...values?.Metas, metasTex], 'Metas')
      setMetasTex('')
    } else {
      toastShow(toast, 'warn', 'Ingrese una Meta.')
    }
  }
  const addCurso = () => {
    if (cursoText.length > 0 && fechaText !== null && efectividad !== null) {
      handleChange([...values?.Cursos, {
        nombre: cursoText,
        fecha: fechaText,
        efectividad: efectividad,
        comentarios: comentariosDesarrolloText
      }], 'Cursos')
      setCursoText('');
      setFechaText(null);
      setEfectividad(null);
      setComentariosDesarrolloText('');
    } else {
      toastShow(toast, 'warn', 'Ingrese todos datos del curso o programa.')
    }
  }

  const CardEvaluacion = React.memo(({ titulo, options, name }) => {
    const [text, setText] = useState([])
    const change = useCallback((value, i) => {
      let t = [...text];
      t[i] = value
      setText(t)
    }, [text])

    useEffect(() => {
      const a = options.map(e => e?.Comentario ? e.Comentario : '');
      setText(a);
    }, [options])

    const handleDropdownChange = useCallback((newValue, index) => {
      // Guardar posición del scroll antes de actualizar
      if (scrollContainer.current) {
        scrollPosition.current = scrollContainer.current.scrollTop;
        isMinorUpdate.current = true;
      }
      const updatedArray = options.map((item, i) => 
        i === index ? { ...item, value: newValue } : item
      );
      handleChange(updatedArray, name);
    }, [options, name])

    const handleCommentBlur = useCallback((index) => {
      // Guardar posición del scroll antes de actualizar
      if (scrollContainer.current) {
        scrollPosition.current = scrollContainer.current.scrollTop;
        isMinorUpdate.current = true;
      }
      const updatedArray = options.map((o, i) => {
        return {
          ...o,
          Comentario: text[i]
        }
      })
      handleChange(updatedArray, name);
    }, [options, text, name])

    return <div>
      <Card
        titulo={<h3>{titulo}</h3>}
        contenido={<div style={{ margin: 10, padding: '0 20px' }}>
          <div>
            {options?.map((e, i) => {
              return <div key={i} style={{ display: 'flex', padding: '5px 0px', alignItems: 'center', gap: 10 }}>
                <div className='col-3' style={{ verticalAlign: 'center' }}>
                  {i + 1}. {e.name}
                </div>
                <div className='col-2'>
                  <Dropdown
                    options={calificaciones}
                    optionLabel='name'
                    optionValue='id'
                    value={e?.value}
                    onChange={event => handleDropdownChange(event.value, i)}
                    style={{
                      width: '100%'
                    }}
                  />
                </div>
                <div className='col-5'>
                  <InputText
                    style={{ width: '100%' }}
                    placeholder='Comentarios'
                    value={text[i]}
                    id={`Comen${i}`}
                    onChange={e => change(e.target.value, i)}
                    onBlur={e => handleCommentBlur(i)}
                  />
                </div>
              </div>
            })}
          </div>
        </div>}
      />
    </div>
  }, (prevProps, nextProps) => {
    return prevProps.options === nextProps.options && prevProps.name === nextProps.name && prevProps.titulo === nextProps.titulo;
  })


  const verfificarResumenGeneral = () => {
    let err
    values?.Resumen.forEach(e => {
      if (!e.value) {
        err = true;
      }
    })
    if (err) {
      toastShow(toast, 'warn', 'Advertencia','Debe de completar el resumen general para continuar.')
    }
    return err;
  }


  useEffect(() => {
    if (posicion) {
      getPerfil();
    }
  }, [posicion])


  useEffect(() => {
    getPerfiles()
  }, [])

  return (
    <div className='p-2'>
      <Toast ref={toast} />
      <ConfirmDialog />
      <Loader loading={loading} />
      <Card
        titulo={<div><h3>Evaluación de Personal</h3></div>}
        contenido={<div 
          ref={scrollContainer}
          className='m-3' 
          style={{ height: 'calc(90vh - 60px)', overflow: 'auto', width: 'auto' }}
        >
          {/* PASO 1 - BUSCAR PERSONAL */}
          <Messages ref={messages} />
          {paso === 1 && <div>
            <div className='mt-3' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
              <h4>Código personal: </h4>
              <InputText
                name='codigo'
                value={values.codigo}
                onChange={handleInputChange}
                maxLength={5}
                onKeyUp={e => {
                  if (e.key === 'Enter') {
                    buscarPersona()
                  }
                }}
              />
              <Button
                icon={'pi pi-search'}
                onClick={buscarPersona}
              />
            </div>
            {values?.idpersonal && <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 20, margin: 40, alignItems: 'center' }}>
              <h3 style={{ textTransform: 'capitalize' }}>Codigo: {values?.idpersonal.toLowerCase()}</h3>
              <h2 style={{ textTransform: 'capitalize' }}>{values?.NombreEmpleado.toLowerCase()}</h2>
              <h4 style={{ textTransform: 'capitalize' }}>{values?.seccion.toLowerCase()}</h4>
              <h4 style={{ textTransform: 'capitalize' }}>{values?.posicion.toLowerCase()}</h4>
              <Button label='Continuar' className='col-4'
                onClick={() => {
                  setPaso(2)
                  getPerfiles()
                  getInfo()
                  messages.current.clear();
                }}
                icon='pi pi-arrow-right'
                iconPos='right'
              // disabled={!isArea}
              />
            </div>}
          </div>}

          {paso !== 1 && <div style={{ position: 'absolute', width: '96%', top: 8, zIndex: 100, height:"4vh" }}>
            <h3 style={{ textTransform: 'capitalize', textAlign: 'end' }}>
              {values?.idpersonal?.toLowerCase()} - {values?.NombreEmpleado?.toLowerCase()}
              <Button
                className='mx-3'
                icon='pi pi-times'
                tooltip='Cancelar evaluación'
                tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} 
                onClick={e => {
                  localStorage.removeItem('evaluacion');
                  setValues(dataBase);
                  setPaso(1);
                }}
              />
            </h3>
          </div>}


          {/* PASO 2 - RESPONSABILIDADES PRINCIPALES */}
          {paso === 2 && <div className='m-4'>
            <div>

              <div
                className='buttonFloatRight'
                onClick={() => {
                  setPaso(3)

                  // if (!(values.Responsabilidades.length < 5 || values.Objetivos.length < 3 || values.Indicadores.length < 3)) {
                  //   setPaso(3)
                  // } else {
                  //   toastShow(toast, 'warn', 'Advertencia','Debe completar todos los campos.')
                  // }
                }}
              >
                <i className='pi pi-arrow-right' style={{ fontSize: 30, color: '#FFF' }} />
              </div>


              {/* RESPONSABILIDADES PRINCIPALES */}
              <div className='border-bottom' style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className='col-8' >

                  <div className='col-12' >
                    <h3>Responsabilidades principales</h3>
                    <p>Agregar al menos 5 responsabilidades ( Claras, Objetivas, Realistas, Enfocadas )</p>
                    <div className='' style={{ display: 'flex', gap: 10 }}>
                      <InputText
                        name='Responsabilidad'
                        value={Responsabilidad}
                        onChange={e => setResponsabilidad(e.target.value)}
                        className='col-10'
                        placeholder='Agregar una responsabilidad'
                        onKeyUp={e => {
                          if (e.key === 'Enter') {
                            addResponsabilidad()
                          }
                        }}
                      />
                      <Button icon='pi pi-plus' onClick={addResponsabilidad} />
                    </div>
                  </div>
                  <div className='mt-4' style={{ minHeight: 150 }}>
                    <div >
                      <ul>
                        {values?.Responsabilidades.map((e, i) => {
                          return <div key={i}>
                            <li style={{ display: 'flex', alignItems: 'center' }}>
                              <span className='pi pi-circle-fill' style={{ fontSize: 8, margin: '0 5px' }} />
                              <span>
                                {e.name}
                              </span>
                              <span>
                                <Button
                                  icon="pi pi-pencil"
                                  className="p-button-rounded p-button-text"
                                  aria-label="Submit"
                                  onClick={n => {
                                    setResponsabilidad(e.name)
                                    const t = values?.Responsabilidades.filter(r => r.name !== e.name)
                                    handleChange(t, 'Responsabilidades')
                                  }}
                                />
                              </span>
                            </li>
                          </div>
                        })}
                      </ul>
                    </div>
                  </div>
                </div>

                <div className='p-4 mt-4 card' style={{ height: '8rem' }}>
                  <p style={{ textAlign: 'end' }}>Posiciones ingresadas previamente:</p>
                  <Dropdown
                    value={posicion}
                    onChange={e => setPosicion(e.target.value)}
                    options={posiciones}
                    optionLabel='label'
                    style={{ minWidth: 400, height: '3rem' }}
                  />
                </div>
              </div>

              {/* OBJETIVOS DE DESEMPEÑO */}
              <div className='border-bottom mt-4'>
                <div>
                  <h3>Objetivos de Desempeño</h3>
                  <p>Agregar al menos 3 Objetivos ( Especificos, Medibles, Alineados, Realistas )</p>
                  <div className='' style={{ display: 'flex', gap: 10 }}>
                    <InputText
                      name='Objetivos'
                      value={Objetivo}
                      onChange={e => setObjetivo(e.target.value)}
                      className='col-8'
                      placeholder='Agregar un objetivo'
                      onKeyUp={e => {
                        if (e.key === 'Enter') {
                          addObjetivo()
                        }
                      }}
                    />
                    <Button icon='pi pi-plus' onClick={addObjetivo} />

                  </div>
                </div>
                <div className='mt-4' style={{ minHeight: 150 }}>
                  <div >
                    <ul>
                      {values?.Objetivos?.map((e, i) => {
                        return <div key={i}>
                          <li style={{ display: 'flex', alignItems: 'center' }}>
                            <span className='pi pi-circle-fill' style={{ fontSize: 8, margin: '0 5px' }} />
                            <span>
                              {e}
                            </span>
                            <span>
                              <Button
                                icon="pi pi-pencil"
                                className="p-button-rounded p-button-text"
                                aria-label="Submit"
                                onClick={n => {
                                  setObjetivo(e)
                                  const t = values?.Objetivos.filter(r => r !== e)
                                  handleChange(t, 'Objetivos')
                                }}
                              />
                            </span>
                          </li>
                        </div>
                      })}
                    </ul>
                  </div>
                </div>
              </div>

              {/* INDICADORES DE MEDICION DE ASIGNACION */}
              <div>
                <div className='mt-4'>
                  <h3>Indicadores de Medición De Asignacion</h3>
                  <p>Agregar al menos 3 Indicadores ( Diarios, Semanales, Mensuales )</p>
                  <div className='' style={{ display: 'flex', gap: 10 }}>
                    <InputText
                      name='Indicadores'
                      value={Indicador}
                      onChange={e => setIndicador(e.target.value)}
                      className='col-8'
                      placeholder='Agregar un indicador'
                      onKeyUp={e => {
                        if (e.key === 'Enter') {
                          addIndicador()
                        }
                      }}
                    />
                    <Button icon='pi pi-plus' onClick={addIndicador} />
                  </div>
                </div>
                <div className='mt-4' style={{ minHeight: 150 }}>
                  <div >
                    <ul>
                      {values?.Indicadores.map((e, i) => {
                        return <div key={i}>
                          <li style={{ display: 'flex', alignItems: 'center' }}>
                            <span className='pi pi-circle-fill' style={{ fontSize: 8, margin: '0 5px' }} />
                            <span>
                              {e}
                            </span>
                            <span>
                              <Button
                                icon="pi pi-pencil"
                                className="p-button-rounded p-button-text"
                                aria-label="Submit"
                                onClick={n => {
                                  setIndicador(e)
                                  const t = values?.Indicadores.filter(r => r !== e)
                                  handleChange(t, 'Indicadores')
                                }}
                              />
                            </span>
                          </li>
                        </div>
                      })}
                    </ul>
                  </div>
                </div>
              </div>

            </div>
          </div>}


          {/* PASO 3 - EVALUACION DE DESEMPEÑO */}
          {paso === 3 && <div className='mt-5'>

            <div
              className='buttonFloatLeft'
              onClick={() => {
                setPaso(2)
              }}
            >
              <i className='pi pi-arrow-left' style={{ fontSize: 30, color: '#FFF' }} />
            </div>
            <div
              className='buttonFloatRight'
              onClick={() => {
                setPaso(4)

                // if (!verificarInformacionPersonal()) {
                //   setPaso(4)
                // }
              }}
            >
              <i className='pi pi-arrow-right' style={{ fontSize: 30, color: '#FFF' }} />
            </div>


            {/* Evaluación de Desempeño */}
            <CardEvaluacion titulo={'Evaluación de Desempeño'} options={values?.Responsabilidades} name='Responsabilidades' />
            {/* Evaluación de Desempeño */}
            <CardEvaluacion titulo={'Competencias Globales'} options={values?.Competencias} name='Competencias' />
            {/* Nivel de conciencia y compromiso */}
            <CardEvaluacion titulo={'Nivel de conciencia y compromiso'} options={values?.ConcienciaCompromiso} name='ConcienciaCompromiso' />
            {/* Cumplimiento en los tiempos de entrega */}
            <CardEvaluacion titulo={'Cumplimiento en los tiempos de entrega'} options={values?.TiempoEntrega} name='TiempoEntrega' />
          </div>}

          {/* PASO 4 - MEJORAMIENTO CONTINUO*/}
          {paso === 4 && <div className='mt-5'>

            <div
              className='buttonFloatLeft'
              onClick={() => {

                setPaso(3)
              }}
            >
              <i className='pi pi-arrow-left' style={{ fontSize: 30, color: '#FFF' }} />
            </div>
            <div
              className='buttonFloatRight'
              onClick={() => {
                setPaso(5)

                // if (!verificarMejoramientoContinuo()) {
                //   setPaso(5)
                // }
              }}
            >
              <i className='pi pi-arrow-right' style={{ fontSize: 30, color: '#FFF' }} />
            </div>

            <div>
              <Card
                titulo={<h3>Mejoramiento continuo</h3>}
                contenido={<div>
                  {/* RESPONSABILIDADES PRINCIPALES */}
                  <div className='mt-4 border-bottom'>

                    {/* MEJORAS IMPLEMENTADAS */}
                    <div>
                      <h3>Mejoras implementadas en el Departamento  </h3>
                      <p>Agregar al menos 3 mejoras ( Efectivas, Implementables, Claras )</p>
                      <div className='' style={{ display: 'flex', gap: 10 }}>
                        <InputText
                          name='Responsabilidad'
                          value={mejorameintoText}
                          onChange={e => setMejorameintoText(e.target.value)}
                          className='col-8'
                          placeholder='Mejoras'
                          onKeyUp={e => {
                            if (e.key === 'Enter') {
                              addMejoramiento()
                            }
                          }}
                        />
                        <Button icon='pi pi-plus' onClick={addMejoramiento} />
                      </div>
                    </div>
                    <div className='mt-4' style={{ minHeight: 150 }}>
                      <div >
                        <ul>
                          {values?.Mejoramiento.map((e, i) =>
                            <li key={i} style={{ display: 'flex', alignItems: 'center' }}>
                              <span className='pi pi-circle-fill' style={{ fontSize: 8, margin: '0 5px' }} />
                              <span>
                                {e}
                              </span>
                              <span>
                                <Button
                                  icon="pi pi-pencil"
                                  className="p-button-rounded p-button-text"
                                  aria-label="Submit"
                                  onClick={n => {
                                    setMejorameintoText(e)
                                    const t = values?.Mejoramiento.filter(r => r !== e)
                                    handleChange(t, 'Mejoramiento')
                                  }}
                                />
                              </span>
                            </li>

                            // <div key={i}><li>{e}</li></div>
                          )}
                        </ul>

                      </div>
                    </div>
                  </div>


                  {/* INNOVACIONES */}
                  <div className='border-bottom'>
                    <div>
                      <h3>Innovaciones introducidas en su area</h3>
                      <p>Agregar al menos 3 innovaciones  ( Creativas, Viables, Eficientes )</p>
                      <div className='' style={{ display: 'flex', gap: 10 }}>
                        <InputText
                          name='Innovaciones'
                          value={innovacionesText}
                          onChange={e => setInnovacionesText(e.target.value)}
                          className='col-8'
                          placeholder='Mejoras'
                          onKeyUp={e => {
                            if (e.key === 'Enter') {
                              addInnovaciones()
                            }
                          }}
                        />
                        <Button icon='pi pi-plus' onClick={addInnovaciones} />
                      </div>
                    </div>
                    <div className='mt-4' style={{ minHeight: 150 }}>
                      <div >
                        <ul>
                          {values?.Innovaciones.map((e, i) =>
                            <li key={i} style={{ display: 'flex', alignItems: 'center' }}>
                              <span className='pi pi-circle-fill' style={{ fontSize: 8, margin: '0 5px' }} />
                              <span>
                                {e}
                              </span>
                              <span>
                                <Button
                                  icon="pi pi-pencil"
                                  className="p-button-rounded p-button-text"
                                  aria-label="Submit"
                                  onClick={n => {
                                    setInnovacionesText(e)
                                    const t = values?.Innovaciones.filter(r => r !== e)
                                    handleChange(t, 'Innovaciones')
                                  }}
                                />
                              </span>
                            </li>

                            // <div key={i}><li>{e}</li></div>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* Metas */}
                  <div>
                    <h3>Enumere la lista de metas o logros en el año anterior</h3>
                    <p>Agregar al menos 3 metas o logros ( Significativos, Claros, Relevantes )</p>
                    <div className='' style={{ display: 'flex', gap: 10 }}>
                      <InputText
                        name='Metas'
                        value={metasTex}
                        onChange={e => setMetasTex(e.target.value)}
                        className='col-8'
                        placeholder='Mejoras'
                        onKeyUp={e => {
                          if (e.key === 'Enter') {
                            addMetas()
                          }
                        }}
                      />
                      <Button icon='pi pi-plus' onClick={addMetas} />
                    </div>
                  </div>
                  <div className='mt-4' style={{ minHeight: 150 }}>
                    <div >
                      <ul>
                        {values?.Metas.map((e, i) =>

                          <li key={i} style={{ display: 'flex', alignItems: 'center' }}>
                            <span className='pi pi-circle-fill' style={{ fontSize: 8, margin: '0 5px' }} />
                            <span>
                              {e}
                            </span>
                            <span>
                              <Button
                                icon="pi pi-pencil"
                                className="p-button-rounded p-button-text"
                                aria-label="Submit"
                                onClick={n => {
                                  setMetasTex(e)
                                  const t = values?.Metas.filter(r => r !== e)
                                  handleChange(t, 'Metas')
                                }}
                              />
                            </span>
                          </li>
                          // <div key={i}><li>{e}</li></div>
                        )}
                      </ul>
                    </div>
                  </div>


                </div>}
              />
            </div>
          </div>}

          {/* PASO 5 - PLAN DE DESARROLLO Y RESUMEN GENERAL */}
          {paso === 5 && <div className='mt-5'>

            <div
              className='buttonFloatLeft'
              onClick={() => {
                setPaso(4)
              }}
            >
              <i className='pi pi-arrow-left' style={{ fontSize: 30, color: '#FFF' }} />
            </div>
            <div
              className='buttonFloatRight'
              onClick={() => {
                const err = verfificarResumenGeneral();
                // const err1 = verificarCursos()
                if (!err) {
                  confirmDialog({
                    message: 'Una vez guardada la evaluación ya no podra ser modificada.',
                    header: 'Guardar',
                    icon: 'pi pi-exclamation-triangle',
                    accept: guardarEvaluacion,
                    acceptLabel: 'Guardar',
                    acceptIcon: 'pi pi-save'
                  })
                }

                confirmDialog({
                  message: 'Una vez guardada la evaluación ya no podra ser modificada.',
                  header: 'Guardar',
                  icon: 'pi pi-exclamation-triangle',
                  accept: guardarEvaluacion,
                  acceptLabel: 'Guardar',
                  acceptIcon: 'pi pi-save'
                })
                // console.log(values)
              }}
            >
              <i className='pi pi-save' style={{ fontSize: 30, color: '#FFF' }} />
            </div>


            <div>
              <Card
                titulo={<h3>Plan de desarrollo de habilidades</h3>}
                contenido={<div className='p-4'>


                  {/* Metas */}
                  <div>
                    <p>Agregar un curso o programa:</p>
                    <div className='p-2' style={{ display: 'flex', gap: 10, width: '100%' }}>
                      <div className='p-float-label col-3' >
                        <InputText
                          name='Curso'
                          value={cursoText}
                          onChange={e => setCursoText(e.target.value)}
                          className='col-12'
                        />
                        <label htmlFor="lefticon">Nombre de curso o programa</label>
                      </div>
                      <div className='p-float-label' >
                        <Calendar
                          value={fechaText}
                          onChange={e => setFechaText(e.target.value)}
                          showIcon
                          showButtonBar
                          dateFormat="dd/mm/yy"
                          monthNavigator
                          yearNavigator
                          yearRange='2010:2030'
                        />
                        <label htmlFor="lefticon">Fecha finalización</label>
                      </div>
                      <div className='p-float-label' >
                        <Dropdown
                          value={efectividad}
                          onChange={e => setEfectividad(e.target.value)}
                          options={[
                            { id: 1, label: 'Efectivo' },
                            { id: 2, label: 'No Efectivo' }
                          ]}
                          style={{ width: 150 }}
                          optionLabel='label'
                          optionValue='id'
                        />
                        <label htmlFor="lefticon">Efectividad</label>
                      </div>
                      <div className='p-float-label' >
                        <InputText
                          value={comentariosDesarrolloText}
                          onChange={e => setComentariosDesarrolloText(e.target.value)}
                          style={{ width: 400 }}
                        />
                        <label htmlFor="lefticon">Comentarios</label>
                      </div>
                      <Button icon='pi pi-plus' onClick={addCurso} />
                    </div>
                  </div>
                  <div className='mt-4' style={{ minHeight: 150 }}>
                    <div >
                      <ul>
                        {values?.Cursos?.map((e, i) =>

                          <li key={i} style={{ display: 'flex', alignItems: 'center' }}>
                            <span className='pi pi-circle-fill' style={{ fontSize: 8, margin: '0 5px' }} />
                            <span>
                              {`${e.nombre}, ${formatFecha(e.fecha)}`} {e?.comentarios ? `, ${e.comentarios}` : ''}
                            </span>
                            <span>
                              <Button
                                icon="pi pi-pencil"
                                className="p-button-rounded p-button-text"
                                aria-label="Submit"
                                onClick={n => {
                                  setCursoText(e.nombre);
                                  setFechaText(e.fecha);
                                  setEfectividad(e.efectividad);
                                  setComentariosDesarrolloText(e.comentarios)
                                  const t = values?.Cursos.filter(r => r !== e)
                                  handleChange(t, 'Cursos')
                                }}
                              />
                            </span>
                          </li>

                          // <div key={i}><li>{`${e.nombre}, ${formatFecha(e.fecha)}`} {e?.comentarios ? `, ${e.comentarios}` : ''}</li></div>

                        )}
                      </ul>
                    </div>
                  </div>


                </div>}

              />

            </div>


            <div className='mt-5'>
              {/* Resumen general de desempeño */}
              <CardEvaluacion titulo={'Resumen general'} options={values?.Resumen} name='Resumen' />

              <div className='m-4 border p-3 text-center'>
                <h4>
                  Calificación: {(getCalificacion()).toFixed(2)} %
                </h4>
              </div>
            </div>
            <p>
              {/* {JSON.stringify(values, null, 3)} */}
            </p>

          </div>}


        </div>}
      />
    </div>
  )
}

export default EvaluacionPersonalScreen 